<div class="field">
  <div class="position-relative d-flex justify-content-center " appDrag (files)="filesDropped($event)">
    <div class="d-flex flex-column w-100">
      <div class="position-relative d-flex flex-column kb-thumbnail-bg-fill" [ngClass]="{'kb-file-container-size-dtcCase':(pageType === 'dtcCase' || pageType === 'downloadInventory' || pageType === 'addDeviceForm') , 'kb-file-container-size': (pageType !== 'dtcCase' && pageType!== 'downloadInventory' && pageType !== 'addDeviceForm')}">
        <div *ngIf="!fileUrl" (click)="fileInput.value=''; fileInput.click()"
          class="d-flex flex-column align-items-center justify-content-center"><img src="../../../../assets/images/select-tick.svg"
            alt="select" class="cursor button-size-select-kb mb-1">
            <div *ngIf="pageType === 'dtcCase'">
              <p class="mb-1 d-flex justify-content-center"><span class="click-upload">Click to upload </span><span class="upload-text">&nbsp;or drag and drop</span></p>
              <p class="mb-0 d-flex justify-content-center upload-text">SVG, PNG, JPG, JPEG or GIF (max. 800x400px)</p>
            </div>
            <div *ngIf="pageType === 'downloadInventory'">
              <p class="mb-1 d-flex justify-content-center"><span class="click-upload">Select File </span><span class="upload-text">&nbsp;or drag and drop</span></p>
              <p class="mb-0 d-flex justify-content-center upload-text">file type as xls or xlsx</p>
            </div>
            <div *ngIf="pageType === 'addDeviceForm'">
              <p class="mb-1 d-flex justify-content-center"><span class="click-upload">Click to upload </span><span class="upload-text">&nbsp;or drag and drop</span></p>
              <p class="mb-0 d-flex justify-content-center upload-text">{{ imageTypesUpperCase }}</p>
            </div>
          </div>
        <ng-container class="d-flex flex-column justify-content-center" *ngIf="fileUrl">
          <img alt=""
            [src]="(isFileTypeImage || !isFileTypeSupport) ? '../../assets/images/'+fileTypeImage : domSanitizer.bypassSecurityTrustUrl(fileUrl)"
            class="w-100 h-100 card-img-top kb-upload-image-container upload-tumbnails-size">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <p class="mr-2 filename" *ngIf="fileName">{{ fileName }} </p>
            <input #fileInput style="display:none;" type="file" class="kb-file-type-displaystyle"
              accept="{{ requiredFileType?.join(', ') }}">
            <p class="filename" *ngIf="fileSize">{{ fileSize | fileSize }}</p>
          </div>
          <mat-progress-bar class="progress-bar" mode="determinate" [value]="uploadProgress" *ngIf="uploadProgress">
          </mat-progress-bar>
        </ng-container>
      </div>
      <div class="text-right align-helmet cursor" *ngIf="fileUrl" (click)="onSoftDelete()">
        <em class="fas fa-trash-alt camera-icon"  [ngClass]="{'delete-icon-position': pageType === 'addDeviceForm'}"></em>
      </div>
    </div>
  </div>
  <input #fileInput style="display:none;" type="file" accept="{{ requiredFileType?.join(', ') }}" (change)="onFileSelected($event)">
</div>

<ng-template #errorDialog let-data>
  <h2 mat-dialog-title>Invalid file type</h2>
  <mat-dialog-content>{{ data }}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="primary">OK</button>
  </mat-dialog-actions>
</ng-template>